import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { UserAuth, UserForSalesManagement } from 'app/services/sales.service';
import { UserInfoModalComponentViewModel } from './user-info-modal.viewmodel';


@Component({
	selector: 'user-info-modal',
	templateUrl: 'user-info-modal.html'
})
export class UserInfoModalComponent {
  
  @ViewChild('modalBody') modalBody: ElementRef;
  
  @Input() viewModel: UserInfoModalComponentViewModel = new UserInfoModalComponentViewModel();

  @Output() onSave:EventEmitter<UserInfoModalComponentViewModel> = new EventEmitter();

  constructor() {
  }
  

  public open(): void {
    this.modalBody.nativeElement.scrollTop = 0;
    this.viewModel.isOpen = true;
  }

  public close(): void {
    this.viewModel.isOpen = false;
  }

  public save(): void {
    this.close();
    this.onSave.emit(this.viewModel);
  }

}


// WEBPACK FOOTER //
// ./src/app/containers/user/modal/user-info-modal.ts